import type { Theme } from '@mui/material';

export const styles = {
  chartStack: {
    height: '100%',
    overflow: 'hidden',
    pb: 1,
  },

  yAxisChartOuterWrapper: {
    width: '3rem',
    flex: '0 0 3 rem',
    overflow: 'hidden',
    minWidth: 0,
  },

  yAxisChartInnerWrapper: {
    height: '100%',
    pl: 1,
    minHeight: 0,
  },

  xAxisAndDataChartOuterWrapper: {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflowX: 'auto',
    overflowY: 'hidden',
    direction: 'rtl',
  },

  xAxisAndDataChartInnerWrapper: (theme: Theme) => ({
    height: '100%',
    position: 'relative',
    direction: 'ltr',
    backgroundColor: theme.colors.white,
  }),
};
